import { __assign, __rest } from "tslib";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
var emojiCategory01 = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 30 30", fill: "currentColor", width: size || "1em", height: size || "1em" }, props),
        React.createElement("g", { id: "smiley-hov" },
            React.createElement("g", { id: "Group-2" },
                React.createElement("path", { id: "Group", d: "M15,25C9.5,25,5,20.5,5,15S9.5,5,15,5c4.9,0,9,3.5,9.8,8.3c0.1,0.5,0.2,1.1,0.2,1.7C25,20.5,20.5,25,15,25z M15,6c-5,0-9,4-9,9s4,9,9,9s9-4,9-9c0-0.5,0-1.1-0.1-1.6C23.1,9.1,19.4,6,15,6z M19.2,17.4l-1-0.2c-0.4,1.6-1.8,2.7-3.4,2.7 s-3-1.1-3.4-2.7l-1,0.2c0.5,2,2.3,3.4,4.4,3.4S18.7,19.4,19.2,17.4z M12,12c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S11.4,12,12,12z M18,12c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S17.4,12,18,12z" })))));
};
emojiCategory01.displayName = 'emojiCategory01';
export default emojiCategory01;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=emojiCategory01.js.map